import { i as r, r as e, c as a, a as t } from './_internal/read-arguments-CPC3VkQ4.mjs';
import { c as o, D as s } from './_internal/create-logger-factory-BmydF_vP.mjs';
export {
  a as DEFAULT_LOGGER_LEVELS,
  L as LOGGER_SILENT_LEVEL
} from './_internal/create-logger-factory-BmydF_vP.mjs';
let g = o({ defaultParams: { ...s, target: c() }, formatMessage: r, readArguments: e }),
  n = a(g);
function c(r = globalThis.console) {
  return function ({ error: e, meta: a, level: o, msgArgs: s = [], msgTemplate: g }) {
    let n = o in r ? r[o] : r.log,
      c = [g, ...s];
    t(a) || c.push(a), n(...c), e && r.error(e);
  };
}
export {
  s as DEFAULT_LOGGER_PARAMS,
  n as createAutoLogger,
  c as createConsoleTarget,
  g as createLogger,
  o as createLoggerFactory
};
//# sourceMappingURL=index.mjs.map
